<template>
  <div class="">
    <div class="box-item">
      <div class="box-item--label is-required">分区类型</div>
      <div class="box-item--cotnent">
        <el-select :value="regionType"
                   size="small"
                   disabled
                   class="edit-form__input"
                   placeholder="请选择">
          <el-option
            v-for="(item, index) in regionTypeList"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
    </div>
    <el-link type="primary"
             @click="addRegionItem"
             :disabled="!canSelectSubareaTotalList.length"
             v-if="visibleAddedBtn"
             style="margin-top: 10px;">
      <el-icon class="el-icon-plus"></el-icon>
      增加分区
    </el-link>
    <br/>
    <template v-for="(item,index) in list">
      <div class="box-space-border"></div>
      <div class="box-item FormWrap">
        <div class="box-item--label is-required">分区名称</div>
        <div class="box-item--cotnent">
          <el-input v-model="item.regionName"
                    size="small"
                    class="edit-form__input"
                    placeholder="请输入"></el-input>
          <el-tag class="index" size="mini">{{index+1}}</el-tag>
        </div>
      </div>
      <el-link
        type="danger"
        @click="removeRegionItem(index)"
        v-if="list.length > 1"
        style="margin-top: 10px;"
        :key="index">移除</el-link>
      <br/>
      <div class="box-item">
        <div class="box-item--label is-required">分区信息</div>
        <div class="box-item--cotnent">
          <el-select v-model="item.regionSelectValue"
                     class="edit-form__input"
                     size="small"
                     multiple
                     filterable
                     placeholder="请选择">
            <el-option
              v-for="item in canSelectSubareaList[index]"
              :key="item.warehouseId"
              :label="item.namec"
              :value="item.warehouseId">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="box-item ">
        <div class="box-item--label is-required">是否支持单询</div>
        <div class="box-item--cotnent">
          <el-radio-group
            v-model="item.isNeedInquiry"
            @input="value=>changeIsNeedInquiry(value,item,index)"
            :disabled="item.exemptionType === 2"
            size="small"
          >
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </div>
      </div>
      <template v-if="isSupportMultiChannel">
        <div class="box-item ">
          <div class="box-item--label is-required">专线api对接渠道代码</div>
          <div class="box-item--cotnent">
            <el-input v-model="item.channelCode"
                      size="small"
                      class="edit-form__input"
                      placeholder="请输入"></el-input>
          </div>
        </div>
      </template>
      <br/>
    </template>

    <div class="box-item" v-if="canSelectSubareaTotalList.length">
      <div class="box-item--label"></div>
      <div class="box-item--cotnent">
        未选：
        <span
          class="color-danger"
          v-for="(item,index) in canSelectSubareaTotalList"
          :key="index">
          {{item.namec}}{{index < canSelectSubareaTotalList.length - 1 ? '、':''}}
        </span>
      </div>
    </div>
    <br/>
  </div>
</template>

<script>
import {rulesNotEmpty} from "@/assets/js/formRules";
import {
  baseDataPriceDetailItem,
  baseDataRegionHeaderItem
} from "@/components/QuotationManagement/components-productQuotation/productQuotation";
import {isArray, isObject} from "my-tools-kit";

let regionTypeArray = [
  {label:'邮编',value:1},
  {label:'国家',value:2},
  {label:'城市',value:3},
  {label:'仓库编码',value:4},
  { label: '邮编分区', value: 5 },
];
let timeTypeArray = [
  {label:'工作日',value:1},
  {label:'自然日',value:2},
];
export default {
  name: "regionNameAndSelect",
  props:{
    regionType:[String,Number],
    list:{//分区列表
      type:Array,
      default:[],
    },
    tableHeadList:{ //表头列表(价格区间)
      type:Array,
      default:()=>[],
    },
    subareaList:{//目的地列表
      type:Array,
      default:()=>[],
    },
    chargeType:[String,Number],// 计费方式 通过 "物流产品详情"或"报价详情"接口获取
    visibleAddedBtn:{//展示新增分区按钮
      type:Boolean,
      default:true,
    },
    isSegment:Boolean,//是否是分段报价
    type:{ // 分段类型 1：全包(头程) 2:派送
      type:Number,
      default:1,
    },
    isSupportMultiChannel:Boolean,//是否多渠道
  },
  data(){
    return {
      /* 表单校验 */
      formRules: {
        no: [{trigger: 'blur', required: false}],
        require: [rulesNotEmpty()],
      },
      // 分区类型
      regionTypeList:regionTypeArray,
    }
  },
  computed:{
    /**
     * 已经选中的列表 [String|number]
     * */
    alreadySelectSubareaList(){
      let alreadySelect = [];
      this.list.forEach(res=>alreadySelect.push(...(res.regionSelectValue || [])));
      return alreadySelect;
    },
    /**
     * 可选分区列表 [Object]
     * */
    canSelectSubareaTotalList(){
      return this.subareaList.filter(res=>!this.alreadySelectSubareaList.includes(res.warehouseId));
    },
    /**
     * 对应分区可选的列表
     */
    canSelectSubareaList(){
      let valueList = this.canSelectSubareaTotalList.map(res=>res.warehouseId);
      return this.list.map(res=>{
        return this.subareaList.filter(item=>{
          let alreadySelectValue = res.regionSelectValue || [];
          return alreadySelectValue.includes(item.warehouseId) || valueList.includes(item.warehouseId);
        });
      })
    },
  },
  methods:{
    addRegionItem(){
      this.list.push(this.newRegionItem());
    },
    newRegionItem(){
      let data = baseDataRegionHeaderItem();
      let firstItem = this.tableHeadList[0]||{};
      Object.assign(data,{
        regionType:this.regionType,//分区类型
        type:this.type || 1,//分段类型 1：全包(头程) 2:派送
        dispatchId:firstItem.dispatchId, //关联派送区间id
        chargeType:this.chargeType,//计费方式: CBM:体积 KG:重量
      })
      data.priceDetailList = this.tableHeadList.map(res=>{
        if(!(res instanceof Object)) res = {};
        return Object.assign(baseDataPriceDetailItem(),{
          chargeSectionDetailId:res.chargeSectionDetailId,// 分区区间id
          sectionStartNum:res.start,// 区间开始值
          sectionEndNum:res.end,// 区间结束值
        })
      });
      return data;
    },
    /**
     * 移除 分区item
     */
    removeRegionItem(index=1){
      this.list.splice(index,1);
    },
    /**
     * 改变值：是否支持单询
     */
    changeIsNeedInquiry(value,item,index){
      if(value){
        if(isArray(item.priceDetailList)) item.priceDetailList.forEach(item=> item.price = 0);
      }else{
        if(isArray(item.priceDetailList)) item.priceDetailList.forEach(item=> item.price = "");
      }
      // if(value && isArray(item.priceDetailList) && item.priceDetailList.length){
      //   item.colspan = item.priceDetailList.length;
      // }else {
      //   item.colspan = 1;
      // }
    },
  },
}
</script>

<style scoped lang="scss">
@import "../boxItem";
</style>



// WEBPACK FOOTER //
// src/components/QuotationManagement/components-productQuotation/regionNameAndSelect/index.vue